// Decisão da guarda do layout _app, isolada do router para poder ser testada
// sem montar rota. O beforeLoad em router.tsx é só o tradutor desta decisão
// para redirect()/contexto.
//
// Sem sessão não há rota pública neste domínio: o app é app.disk.lai.ia.br e
// quem chega deslogado vai para /auth. A página de marketing mora em outro
// endereço (disk.lai.ia.br, repositório disk-lp) e não passa por esta guarda.
//
// Depois da sessão vêm os passos obrigatórios do primeiro acesso, todos em
// rotas fullscreen fora deste layout (por isso não há loop): trocar a senha
// temporária, criar a marca e escolher um plano.
export type AppGuardDecision =
  | { kind: "app" }
  | { kind: "no-access" }
  | {
      kind: "redirect";
      to:
        | "/auth"
        | "/change-password-required"
        | "/onboarding/organization"
        | "/subscription"
        | "/";
    };

export function appGuardDecision(input: {
  hasSession: boolean;
  mustChangePassword: boolean;
  hasOrganization: boolean;
  companyOnboarded: boolean;
  subscriptionActive: boolean;
  allowed: boolean;
  pathname: string;
}): AppGuardDecision {
  if (!input.hasSession) return { kind: "redirect", to: "/auth" };
  // Primeiro acesso com senha padrão: obriga a troca antes de entrar no app.
  if (input.mustChangePassword) return { kind: "redirect", to: "/change-password-required" };
  // Cadastro público, passo de nomear a empresa. Duas condições, porque são
  // dois estados diferentes:
  //
  //  - `hasOrganization` falso: conta sem marca nenhuma. Não nasce mais assim
  //    (o cadastro é transacional desde features/signup no back), mas as contas
  //    órfãs do modelo antigo continuam no banco — e sem org toda tela interna
  //    consulta por org e vem vazia.
  //  - `companyOnboarded` falso: a marca EXISTE, criada junto com a conta, mas
  //    ainda carrega o nome provisório da pessoa. É o estado normal de quem
  //    acabou de confirmar o email.
  if (!input.hasOrganization || !input.companyOnboarded) {
    return { kind: "redirect", to: "/onboarding/organization" };
  }
  // Assinatura paga. Este degrau é EXPERIÊNCIA, não
  // autoridade — quem chamar a API direto toma 402 do guard do back
  // (features/plans/guard.ts). Se os dois divergirem, quem manda é o back.
  if (!input.subscriptionActive) return { kind: "redirect", to: "/subscription" };
  // Rota fora da permissão do papel → raiz (base). A raiz em si NUNCA
  // redireciona para si mesma: um papel sem "Início → Abrir a tela"
  // (dashboard.root.view) teria "/" negado e cairia num loop de redirect
  // infinito — a guarda não tem para onde mandar quem não pode ver nem a
  // base, então devolve um estado explícito de "sem acesso" em vez de
  // insistir no redirect.
  if (!input.allowed) {
    if (input.pathname === "/") return { kind: "no-access" };
    return { kind: "redirect", to: "/" };
  }
  return { kind: "app" };
}
